module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/core-js/symbol.js
// module id = 590
// module chunks = 22 40